module.exports.Cabang = {
  "Medan Putri Hijau": {
    label: "Medan Putri Hijau",
    value: "Medan Putri Hijau",
    address: "Jl. Kol. Yos Sudarso No.20, Silalas, Kec. Medan Bar., Kota Medan, Sumatera Utara 20235",
    phone_number: "061-6645745",
    whatsapp: "082165552328",
    pic: "Louis",
    open: [
      "Senin - Jumat : 08.00 - 16.30",
      "Sabtu: 08.00 - 12.00"
    ],
    whatsapplink: "https://api.whatsapp.com/send?phone=6282165552328&text=Halo%20Louis,%20Saya%20mau%20bertanya%20tentang ",
    gmap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.9192435207747!2d98.67129441475862!3d3.605960097376004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x303131eedf550823%3A0x26d4dc89f6df4766!2sPT%20Capella%20Multidana!5e0!3m2!1sen!2sid!4v1618547443517!5m2!1sen!2sid"
  },
  "Medan Nibung Raya": {
    label: "Medan Nibung Raya",
    value: "Medan Nibung Raya",
    address: "Jl. Nibung Raya No.146-148, Petisah Tengah, Medan Petisah, Medan City, North Sumatra 20111",
    phone_number: "061-4575838",
    whatsapp: "082282604233",
    pic: "Relin",
    open: [
      "Senin - Jumat : 08.00 - 16.30",
      "Sabtu: 08.00 - 12.00"
    ],
    whatsapplink: "https://api.whatsapp.com/send?phone=6282282604233&text=Halo%20Relin,%20Saya%20mau%20bertanya%20tentang ",
    gmap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.9925244589085!2d98.66290111903085!3d3.5891891048600177!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x303131d73796c77b%3A0x84cd83edbbd25afe!2sCapella%20Multidana%20Medan!5e0!3m2!1sen!2sid!4v1629099619238!5m2!1sen!2sid"
  },
  "Banda Aceh": {
    label: "Banda Aceh",
    value: "Banda Aceh",
    address: "Lampeuneurut Gampong, Banda Raya, Banda Aceh City, Aceh 23231",
    phone_number: "085270247218",
    whatsapp: "089657335158",
    pic: "Wildan",
    open: [
      "Senin - Jumat : 08.00 - 16.30",
      "Sabtu: 08.00 - 12.00"
    ],
    whatsapplink: "https://api.whatsapp.com/send?phone=6289657335158&text=Halo%20Wildan,%20Saya%20mau%20bertanya%20tentang ",
    gmap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3971.33089094355!2d95.31188211476578!3d5.517815495999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x304039f3ca8f5607%3A0x1905bba2032361df!2sCapella%20Daihatsu%20Banda%20Aceh!5e0!3m2!1sen!2sid!4v1618547594310!5m2!1sen!2sid"
  },
  "Lhokseumawe": {
    label: "Lhokseumawe",
    value: "Lhokseumawe",
    address: "Jl. Samudera Baru 15, Simpang Empat, Banda Sakti, Kota Lhokseumawe, Aceh",
    phone_number: "085296066268",
    whatsapp: "082277152707",
    pic: "Achmad",
    open: [
      "Senin - Jumat : 08.00 - 16.30",
      "Sabtu: 08.00 - 12.00"
    ],
    whatsapplink: "https://api.whatsapp.com/send?phone=6282277152707&text=Halo%20Achmad,%20Saya%20mau%20bertanya%20tentang ",
    gmap: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d248.34646573765554!2d97.1472612!3d5.1768735!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNcKwMTAnMzcuMCJOIDk3wrAwOCc1MC4xIkU!5e0!3m2!1sen!2sid!4v1618583115617!5m2!1sen!2sid"
  },
  "Bireuen": {
    label: "Bireuen",
    value: "Bireuen",
    address: "Geudong Geudong, Juang City, Bireuen Regency, Aceh 24261",
    phone_number: "0644-21849",
    whatsapp: "085231114997",
    pic: "Assurawati",
    open: [
      "Senin - Jumat : 08.00 - 16.30",
      "Sabtu: 08.00 - 12.00"
    ],
    whatsapplink: "https://api.whatsapp.com/send?phone=6285231114997&text=Halo%20Assurawati,%20Saya%20mau%20bertanya%20tentang ",
    gmap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3973.3560337395797!2d96.70100941476439!3d5.206616496222079!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3047436743439179%3A0x17e166ae93e13e1c!2sPt%20Capella%20Multidana%20Bireuen!5e0!3m2!1sen!2sid!4v1618547646937!5m2!1sen!2sid"
  },
  "Meulaboh": {
    label: "Meulaboh",
    value: "Meulaboh",
    address: "Jl. Swadaya, Drien Rampak, Johan Pahlawan, Kabupaten Aceh Barat, Aceh 23611",
    phone_number: "085249161187",
    whatsapp: "082272936240",
    pic: "Suci",
    open: [
      "Senin - Jumat : 08.00 - 16.30",
      "Sabtu: 08.00 - 12.00"
    ],
    whatsapplink: "https://api.whatsapp.com/send?phone=6282272936240&text=Halo%20Suci,%20Saya%20mau%20bertanya%20tentang ",
    gmap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3979.347954966037!2d96.12781131476035!3d4.1518055969814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNMKwMDknMDYuNSJOIDk2wrAwNyc0OC4wIkU!5e0!3m2!1sen!2sid!4v1618582922750!5m2!1sen!2sid"
  },
  "Pekanbaru": {
    label: "Pekanbaru",
    value: "Pekanbaru",
    address: "Pekanbaru, Tengkerang Barat, Marpoyan Damai, Pekanbaru City, Riau 28292",
    phone_number: "082268973032",
    whatsapp: "081275098274",
    pic: "Sardo",
    open: [
      "Senin - Jumat : 08.00 - 16.30",
      "Sabtu: 08.00 - 12.00"
    ],
    whatsapplink: "https://api.whatsapp.com/send?phone=6281275098274&text=Halo%20Sardo,%20Saya%20mau%20bertanya%20tentang ",
    gmap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.6543195352156!2d101.44171131475335!3d0.519499999620988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMMKwMzEnMTAuMiJOIDEwMcKwMjYnMzguMCJF!5e0!3m2!1sen!2sid!4v1619030842532!5m2!1sen!2sid"
  },
  "Duri": {
    label: "Duri",
    value: "Duri",
    address: "Lintas duri dumai km 3, Balai Makam, Kec. Mandau, Kabupaten Bengkalis, Riau 28983",
    phone_number: "082268970330",
    whatsapp: "082382706629",
    pic: "Ikhwan",
    open: [
      "Senin - Jumat : 08.00 - 16.30",
      "Sabtu: 08.00 - 12.00"
    ],
    whatsapplink: "https://api.whatsapp.com/send?phone=6282382706629&text=Halo%20Ikhwan,%20Saya%20mau%20bertanya%20tentang ",
    gmap: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15955.098303876948!2d101.1804223!3d1.3105923!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x7058432f385377cc!2sMotor%20dan%20mobil%20seken!5e0!3m2!1sen!2sid!4v1618583282112!5m2!1sen!2sid"
  },
  "Dumai": {
    label: "Dumai",
    value: "Dumai",
    address: "Ratu Sima, West Dumai, Dumai City, Riau 28826",
    phone_number: "082384546007",
    whatsapp: "082391818324",
    pic: "Nicco",
    open: [
      "Senin - Jumat : 08.00 - 16.30",
      "Sabtu: 08.00 - 12.00"
    ],
    whatsapplink: "https://api.whatsapp.com/send?phone=6282391818324&text=Halo%20Nicco,%20Saya%20mau%20bertanya%20tentang ",
    gmap: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d997.0309222146404!2d101.4253189!3d1.6699908!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x229bc6d214b2c595!2sPT.%20CAPELLA%20MULTIDANA!5e0!3m2!1sen!2sid!4v1618547859025!5m2!1sen!2sid"
  },
  "Pangkalan kerinci": {
    label: "Pangkalan kerinci",
    value: "Pangkalan kerinci",
    address: "Pangkalan Kerinci Kota, Kec. Pangkalan Kerinci, Kabupaten Pelalawan, Riau",
    phone_number: "085365993153",
    whatsapp: "081277156100",
    pic: "Tanta",
    open: [
      "Senin - Jumat : 08.00 - 16.30",
      "Sabtu: 08.00 - 12.00"
    ],
    whatsapplink: "https://api.whatsapp.com/send?phone=6281277156100&text=Halo%20Tanta,%20Saya%20mau%20bertanya%20tentang ",
    gmap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.7302043262903!2d101.85555071475336!3d0.3807932997221809!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31d5c4922adec7b1%3A0xf1da717ca22ea20b!2sPt.%20Capella%20Multidana!5e0!3m2!1sen!2sid!4v1618547772485!5m2!1sen!2sid"
  },
  "Perawang": {
    label: "Perawang",
    value: "Perawang",
    address: "Perawang Barat, Tualang, Siak Regency, Riau 28685",
    phone_number: "082384860394",
    whatsapp: "085365912347",
    pic: "Ilman",
    open: [
      "Senin - Jumat : 08.00 - 16.30",
      "Sabtu: 08.00 - 12.00"
    ],
    whatsapplink: "https://api.whatsapp.com/send?phone=6285365912347&text=Halo%20Ilman,%20Saya%20mau%20bertanya%20tentang ",
    gmap: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1994.7685494538366!2d101.58094090866138!3d0.6802802011925472!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMMKwNDAnNDUuMSJOIDEwMcKwMzQnNTAuNCJF!5e0!3m2!1sen!2sid!4v1618640459853!5m2!1sen!2sid"
  },
  "Padang": {
    label: "Padang",
    value: "Padang",
    address: "Jl. Prof. Dr. Hamka No.123, Parupuk Tabing, Kec. Koto Tangah, Kota Padang, Sumatera Barat 25586",
    phone_number: "082286218933 / 082298789838",
    whatsapp: "082382754789",
    pic: "Syahrial",
    open: [
      "Senin - Jumat : 08.00 - 16.30",
      "Sabtu: 08.00 - 12.00"
    ],
    whatsapplink: "https://api.whatsapp.com/send?phone=6282382754789&text=Halo%20Syahrial,%20Saya%20mau%20bertanya%20tentang ",
    gmap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.334808331545!2d100.34969071475359!3d-0.8920086993492808!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2fd4b8aaf2f4d37b%3A0x2498e72b61569e10!2sCapella%20Daihatsu%20Padang!5e0!3m2!1sen!2sid!4v1618547831876!5m2!1sen!2sid"
  },
}
